import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntityBrowserBar from 'components/organisms/Bars/EntityBrowserBar/EntityBrowserBar';

const StyledCollectionEntityBrowserBar = styled(EntityBrowserBar)`
  ${ComponentStyles}
`;

StyledCollectionEntityBrowserBar.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntityBrowserBar;
